<!-- 直播列表 -->

<template>
  <div class="main">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-input class="s_input" placeholder="搜索直播名称" suffix-icon="el-icon-search" v-model="liveName" :clearable="true"
        @change="onSearch"></el-input>
      <el-select v-model="status" placeholder="选择状态" clearable @change="onSearch">
        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button class="btn" type="primary" @click="handleApply(1)">新增直播</el-button>
    </div>
    <div class="globle_border" v-loading="loading">
      <!-- 表格 -->
      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="290" show-overflow-tooltip prop="liveName" label="直播名称"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip prop="categoryName" label="直播分类"></el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="price" label="直播价格(元)">
            <template slot-scope="scope">
              <span>{{ scope.row.costAttr == 0 ? "免费" : scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="130" prop="buyerCount" show-overflow-tooltip label="已预约人数"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="teacherName" label="直播主讲专家"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="watchPoints" label="观看积分"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="sharePoints" label="分享积分"></el-table-column>
          <el-table-column min-width="180" show-overflow-tooltip prop="startTime" label="直播开始时间"></el-table-column>
          <el-table-column min-width="180" show-overflow-tooltip prop="endTime" label="直播结束时间"></el-table-column>
          <el-table-column min-width="180" show-overflow-tooltip prop="createdTime" label="发布时间"></el-table-column>
          <el-table-column label="是否推荐" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.switch" inactive-color="#E2E2E2"
                @change="changeStatus(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="上下架状态" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.onlineStatus" inactive-color="#E2E2E2"
                @change="changeOnlineStatus(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="liveStatus" label="状态">
            <template slot-scope="scope">
              <div style="color: #EE1A1A;" v-if="scope.row.liveStatus == 1">待开播</div>
              <div v-if="scope.row.liveStatus == 2">直播中</div>
              <div v-if="scope.row.liveStatus == 3">已结束</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="360" min-width="360" fixed="right">
            <template slot-scope="scope">
              <el-button size="small" class="btn" type="primary" plain @click="handleAfter(scope.row)">课后问答</el-button>
              <el-button size="small" class="btn" type="primary" plain @click="handleBuy(scope.row)">已购用户</el-button>
              <el-button size="small" class="btn" type="primary" plain @click="handleApply(scope.row)"
                v-if="scope.row.liveStatus == 1">编辑</el-button>
              <el-button size="small" class="btn" type="primary" plain @click="handleCheck(scope.row)"
                v-if="scope.row.liveStatus != 1">查看</el-button>
              <el-button size="small" class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      liveName: "",
      status: "",
      statusOptions: [
        {
          label: "待开播",
          value: "1",
        },
        {
          label: "直播中",
          value: "2",
        },
        {
          label: "已结束",
          value: "3",
        },
      ], // 状态options
      shelfStatus: "", // 选择上下架状态
      shelfOptions: [{
        value: "1",
        label: "上架",
      },
      {
        value: "0",
        label: "下架",
      },
      ],
      // 表格数据
      tableData: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.selectLiveInfoPage()
  },
  methods: {
    // 获取列表
    selectLiveInfoPage() {
      this.loading = true
      this.$axios
        .get(this.$api.selectLiveInfoPage, {
          params: {
            liveName: this.liveName || null,
            liveStatus: this.status || null,
            onlineStatus: this.shelfStatus,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = (res.result.list || []).map(e => {
              return {
                ...e,
                switch: e.recommendFlag == 1 ? true : false,
                onlineStatus: e.onlineStatus == 1 ? true : false,
              }
            }) || []
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },

    // 上下架状态
    changeOnlineStatus(row) {
      const originalSwitch = row.onlineStatus
      this.$confirm(`确定${row.onlineStatus ? "上架" : "下架"}吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.updateOnlineStatusLive, {
              id: row.id,
              updateOnlineStatus: row.onlineStatus ? 1 : 0,
            })
            .then(res => {
              this.$set(row, "onlineStatus", originalSwitch)
              this.$message.success(res.desc)
              this.selectLiveInfoPage()
            })
            .catch(err => {
              this.$set(row, "onlineStatus", !originalSwitch)
              this.$message.error(err.desc)
              this.selectLiveInfoPage()
            })
        })
        .catch(() => {
          this.$set(row, "onlineStatus", !originalSwitch)
          this.selectLiveInfoPage()
        })
    },
    // 是否推荐
    changeStatus(row) {
      const originalSwitch = row.switch
      this.$confirm(`确定${row.switch ? "开启" : "关闭"}推荐吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.updateLiveRecommendFlag, {
              id: row.id,
              recommendFlag: row.switch ? 1 : 0,
            })
            .then(res => {
              this.$set(row, "switch", originalSwitch)
              this.$message.success(res.desc)
              this.selectLiveInfoPage()
            })
            .catch(err => {
              this.$set(row, "switch", !originalSwitch)
              this.$message.error(err.desc)
              this.selectLiveInfoPage()
            })
        })
        .catch(() => {
          this.$set(row, "switch", !originalSwitch)
          this.selectLiveInfoPage()
        })
    },
    // 新增 / 修改
    handleApply(row) {
      if (row == 1) {
        this.$router.push("/liveManage/detail/applyLive")
      } else {
        this.$router.push({
          path: "/liveManage/detail/applyLive",
          query: {
            id: row.id,
          },
        })
      }
    },
    // 删除
    handleDelete(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .get(this.$api.deleteLiveInfo, {
              params: {
                id: row.id,
                roomId: row.roomId,
              },
            })
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.selectLiveInfoPage()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message("取消删除")
        })
    },
    handleCheck(row) {
      this.$router.push({
        path: "/liveManage/detail/liveInfo",
        query: {
          id: row.id,
        },
      })
    },
    handleBuy(row) {
      this.$router.push({
        path: "/courseManage/detail/buyerList",
        query: {
          id: row.id,
          type: 2,
        },
      })
    },
    handleAfter(row) {
      this.$router.push({
        path: "/liveManage/detail/afterClassQA",
        query: {
          id: row.id,
          type: 1,  // 0 课程 1直播
        },
      })
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.selectLiveInfoPage()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.pageSize = e
      this.onSearch()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectLiveInfoPage()
    },
  },
}
</script>

<style lang="scss" scoped>
.main {}
</style>
